import React from 'react';
import { kmToMiles } from '../../utils/distance';

const SpeciesAnalysis = ({ species }) => {
  return (
    <section className="px-12 py-24 max-w-7xl mx-auto">
      <div className="max-w-5xl">
        <span className="font-label text-xs uppercase tracking-widest text-primary mb-4 block">Field Notes</span>
        <h2 className="font-headline text-5xl mb-16 text-on-surface italic">About the {species.name}</h2>

        <div className="grid md:grid-cols-2 gap-20 text-slate-300 font-body leading-relaxed">
          <div className="space-y-6">
            <h4 className="text-primary font-headline text-2xl">Species Profile</h4>
            <p className="text-lg leading-relaxed">
              {species.description}
            </p>
            <p>
              The {species.name} (<em>{species.scientificName}</em>) is classified within the <strong className="text-on-surface">{species.category}</strong> group.
              Each year, this remarkable species undertakes a migration covering <strong className="text-on-surface">{kmToMiles(species.distance)}</strong>,
              departing in <strong className="text-on-surface">{species.seasons.depart}</strong> and arriving at its destination
              by <strong className="text-on-surface">{species.seasons.arrive}</strong>, before returning
              in <strong className="text-on-surface">{species.seasons.return}</strong>.
            </p>
            <p>
              Currently listed as <strong className={
                species.status === 'Least Concern' ? 'text-secondary' :
                species.status === 'Endangered' || species.status === 'Critically Endangered' ? 'text-error' :
                'text-primary'
              }>{species.status}</strong> on the IUCN Red List, this species is monitored through
              collaborative efforts between researchers worldwide using satellite telemetry,
              geolocators, and citizen science platforms like eBird and Movebank.
            </p>
          </div>

          <div className="space-y-6">
            <h4 className="text-secondary font-headline text-2xl">Observer's Guide</h4>
            <p className="text-lg leading-relaxed">
              {species.tips}
            </p>
            <p>
              The migration route of the {species.name} spans {species.route.length} documented waypoints,
              from <strong className="text-on-surface">{species.route[0]?.name}</strong> to{' '}
              <strong className="text-on-surface">{species.route[species.route.length - 1]?.name}</strong>.
              Observers should note that timing can vary by several weeks depending on weather
              patterns, food availability, and individual variation.
            </p>
            <p>
              The Digital Field Journal tracks these movements through a combination of historical
              data archives and contemporary field research. For the most up-to-date sighting
              reports, we recommend cross-referencing with Journey North and local birding or
              wildlife organisations in the regions along this species' migratory corridor.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpeciesAnalysis;
